import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[max]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxValidator,
      multi: true
    }
  ]
})
export class MaxValidator implements Validator {
  @Input() max: number;
  validate(
    c: AbstractControl
  ): {
    [key: string]: any;
  } {
    const v = c.value;
    return v > this.max ? { max: true } : null;
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[min]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinValidator,
      multi: true
    }
  ]
})
export class MinValidator implements Validator {
  @Input() min: number;
  validate(
    c: AbstractControl
  ): {
    [key: string]: any;
  } {
    const v = c.value;
    return v < this.min ? { min: true } : null;
  }
}

@Directive({
  selector: '[txLess]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: LessValidator,
      multi: true
    }
  ]
})
export class LessValidator implements Validator {
  @Input() txLess: number;
  validate(
    c: AbstractControl
  ): {
    [key: string]: any;
  } {
    const v = c.value;
    return v >= this.txLess ? { less: true } : null;
  }
}

@Directive({
  selector: '[txGreater]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: GreaterValidator,
      multi: true
    }
  ]
})
export class GreaterValidator implements Validator {
  @Input() txGreater: number;
  validate(
    c: AbstractControl
  ): {
    [key: string]: any;
  } {
    const v = c.value;
    return v <= this.txGreater ? { greater: true } : null;
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[maxlength]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxLengthValidator,
      multi: true
    }
  ]
})
export class MaxLengthValidator implements Validator {
  @Input() maxlength: number;
  validate(
    c: AbstractControl
  ): {
    [key: string]: any;
  } {
    const v = c.value;
    return v && v.toString().length > this.maxlength ? { maxlength: true } : null;
  }
}
